import { takeEvery, put, call } from "redux-saga/effects";
import * as action from "./actions";
import * as api from "../../apis";

export function* getMerchants(request: any) {
  try {
    let response = yield call(api.fetchMerchants, request.payload);
    yield put(action.addMerchants(response));
  } catch (e) {
    yield put(action.getMerchantsFailure());
  }
}

export function* watchGetMerchants() {
  yield takeEvery(action.GET_MERCHANTS, getMerchants);
}

export function* getMerchant(request: any) {
  try {
    let response = yield call(api.fetchMerchant, request.payload);
    yield put(action.addMerchants(response));
  } catch (e) {
    yield put(action.getMerchantsFailure());
  }
}

export function* watchGetMerchant() {
  yield takeEvery(action.GET_MERCHANT, getMerchant);
}



// WEBPACK FOOTER //
// ./client/modules/Merchant/sagas.ts